import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page non trouvée — Pierre Affrètement</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6">
        <div className="text-[#E8902A] font-heading font-black text-8xl md:text-9xl leading-none mb-4">
          404
        </div>
        <h1 className="text-white font-heading font-bold text-2xl md:text-3xl mb-3">
          Page non trouvée
        </h1>
        <p className="text-slate-400 text-base max-w-md mb-8">
          La page que vous cherchez n’existe pas ou a été déplacée.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-[#E8902A] hover:bg-[#d07820] text-white font-heading font-bold text-sm tracking-widest uppercase px-7 py-3 rounded-xl transition-colors duration-200"
          data-testid="notfound-home-link"
        >
          <ArrowLeft size={16} />
          Retour à l’accueil
        </Link>
      </div>
    </>
  );
}
